import gql from 'graphql-tag';

export const fetchSupplierMatchQuery = gql`
  query SupplierMatch($from: timestamptz, $to: timestamptz, $supplier_id: uuid, $limit: Int!, $offset: Int!) {
    match_report_aggregate(where: { created_at: { _gte: $from, _lte: $to}, supplier_id: { _eq: $supplier_id }}) {
      aggregate {
        count
      }
    }
    match_report(where: { created_at: { _gte: $from, _lte: $to}, supplier_id: { _eq: $supplier_id }}, order_by: { created_at: desc}, limit: $limit, offset: $offset) {
      buyer_username
      buyer_name
      buyer_taxid
      item_description
      item_price
      item_currency
      item_uom
      item_sku
      item_classname
      item_classcode
      search_words
      supplier_name
      supplier_taxid
      created_at
    }
  }
`;
export const fetchReportData = gql`
query searchChart($from: timestamptz, $to: timestamptz, $supplier_id: uuid, $buyer_id: String!, $classcode: String!, $search: String!, $process_type: String!) {
  search_report(args: {buyer_id: $buyer_id, classcode: $classcode, search: $search, process_type: $process_type}, where: {created_at: {_gte: $from, _lte: $to}, supplier_id: {_eq: $supplier_id}}, order_by: {created_at: asc}) {
    classcode
    classname
    created_at
    item_description
    item_price
    item_currency
    item_uom
    item_sku
    search_words
    buyer_username
    buyer_name
    buyer_taxid
    process_type
  }
}
`;

export const fetchSearchReportQuery = gql`
query SupplierMatch($from: timestamptz!, $to: timestamptz!, $supplier_id: uuid, $limit: Int!, $offset: Int!, $buyer_id: String!, $classcode: String!, $search: String!, $process_type: String!) {
  search_report_aggregate(args: {buyer_id: $buyer_id, classcode: $classcode, search: $search, process_type: $process_type}, where: {created_at: {_gte: $from, _lte: $to}, supplier_id: {_eq: $supplier_id}}){
    aggregate {
      count
    }
  }
  search_report(args: {buyer_id: $buyer_id, classcode: $classcode, search: $search, process_type: $process_type}, where: {created_at: {_gte: $from, _lte: $to}, supplier_id: {_eq: $supplier_id}}, limit: $limit, offset: $offset) {
    buyer_id
    buyer_username
    buyer_name
    buyer_taxid
    item_description
    item_price
    item_currency
    item_uom
    item_sku
    item_classname
    item_classcode
    search_words
    supplier_name
    supplier_taxid
    created_at
    classcode
    classname
    process_type
  }
}
`;

export const fetchCategories = gql`
query searchCategories($from: timestamptz, $to: timestamptz, $search: String) {
  report_match(distinct_on: [classcode], where: {created_at: {_gte: $from, _lte: $to}, _or: [{item_classname: {_ilike: $search}}, {classname: {_ilike: $search}},{item_classcode: {_ilike: $search}}, {classcode: {_ilike: $search}}] }) {
    classcode
    classname
    item_classcode
    item_classname
  }
}
`;

export const fetchBuyers = gql`
query searchBuyers($from: timestamptz, $to: timestamptz, $search: String) {
  report_match(distinct_on: [buyer_id], where: {created_at: {_gte: $from, _lte: $to}, _or: [{buyer_name:{_ilike:$search}}, {buyer_taxid: {_ilike: $search}}]}) {
    buyer_name,
    buyer_id,
    buyer_taxid,
  }
}
`;

export const fetchProcessTypes = gql`
query searchProcessType($from: timestamptz, $to: timestamptz, $search: String) {
  report_match(distinct_on: [process_type], where: {created_at: {_gte: $from, _lte: $to}, _or: [{process_type:{_ilike:$search}}, {buyer_taxid: {_ilike: $search}}]}) {
    process_type
  }
}
`;

export const loadProcessTypes = gql`
query searchProcessType {
  report_match(distinct_on: [process_type]) {
    process_type
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/report.js